import MaterialSpeedDial, { SpeedDialProps } from '@mui/material/SpeedDial';

export function SpeedDial(props: SpeedDialProps) {
    return <MaterialSpeedDial data-testid={'SpeedDial-container'} {...props} />;
}

export default SpeedDial;
